import React from 'react'
import { Outlet } from 'react-router-dom'
export default function System() {
  return (
    <div className='product'>
      <Outlet/>
    </div>
  )
}
